import { useState } from "react";
import { useSeo } from "~/lib/seo/useSeo";
import { BriefForm } from "~/ui/Hire/BriefForm";
import { ContactAlternatives } from "~/ui/Hire/ContactAlternatives";
import { ThankYou } from "~/ui/Hire/ThankYou";

type FormState = "idle" | "sent";

export function Hire() {
  useSeo({
    title: "Hire",
    description:
      "Send JGson a brief — service line, budget band, timeline, message. João replies within 24h.",
    pathname: "/hire",
  });
  const [state, setState] = useState<FormState>("idle");

  return (
    <section className="mx-auto flex w-full max-w-3xl flex-col gap-8 px-4 py-12 sm:py-16">
      <header className="flex flex-col gap-2">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-jg-fg-muted">
          Hire JGson
        </p>
        <h1 className="font-display text-3xl font-semibold leading-tight tracking-tight sm:text-5xl">
          Brief us in one form,{" "}
          <span className="text-jg-fg-muted">or just say hello.</span>
        </h1>
        <p className="mt-2 text-sm leading-relaxed text-jg-fg-muted">
          Tell us what you're trying to build. Names + email so João can
          reply, a rough budget band + timeline so we can be honest about
          fit, and as much detail as you can spare on the actual problem.
        </p>
      </header>

      {state === "sent" ? (
        <ThankYou onReset={() => setState("idle")} />
      ) : (
        <BriefForm onSubmitted={() => setState("sent")} />
      )}

      <div className="flex flex-col gap-3">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-jg-fg-muted">
          Or skip the form
        </p>
        <ContactAlternatives />
      </div>
    </section>
  );
}
